'use strict';

import _ from 'lodash';

import ReferenceSet from '~/shared/src/mm/ReferenceSet';


class ReferenceSetTemplateStringResolver {
    rawMode : boolean = false;

    protected _referenceSet? : ReferenceSet;

    constructor( referenceSet : ReferenceSet | undefined ) {
        this._referenceSet = referenceSet;

        return new Proxy( this, this );
    }

    set( target : ReferenceSetTemplateStringResolver, attribute : string, value : any ) {
        let retVal = false;

        if ( attribute === 'rawMode' ) {
            retVal = true;
            this.rawMode = value;
        }

        return retVal;
    }

    get( target : ReferenceSetTemplateStringResolver, attribute : Symbol ) : ( () => string );
    get( target : ReferenceSetTemplateStringResolver, attribute : string ) : string;
    get( target : ReferenceSetTemplateStringResolver, attribute : string | Symbol ) : string | ( () => string ) {
        let retVal : string | ( () => string ) = '';

        if ( typeof attribute === 'symbol' ) {
            if ( attribute === Symbol.toPrimitive ) {
                retVal = () => {
                    return 'referenceSet';
                };
            }
        }
        else if ( this._referenceSet ) {
            retVal = attribute as string;

            attribute = _.lowerFirst( attribute as string );

            if ( attribute === 'setId' ) {
                retVal = String( this._referenceSet.id );
            }
            else if (
                attribute === 'referenceSetName' || attribute === 'setName'
                || attribute === 'referenceTypeName' || attribute === 'typeName'
            ) {
                retVal = !this.rawMode ? this._referenceSet.referenceTypeLabel : this._referenceSet.referenceTypeName;
            }
            else if ( attribute === 'cardinality' ) {
                retVal = this._referenceSet.cardinality;
            }
            else if ( attribute === 'typeId' ) {
                retVal = String( this._referenceSet.referenceTypeId );
            }
        }

        if ( !retVal ) {
            retVal = `reference.${String( attribute )}`;
        }

        return retVal;
    }
}

export default ReferenceSetTemplateStringResolver;
